// Generated from Swagger on 2025-08-27T14:46:24.217Z
import {
  useSuspenseQuery,
  useQuery,
  useMutation,
  useQueryClient,
  UseSuspenseQueryOptions,
  UseQueryOptions,
  UseMutationOptions,
} from "@tanstack/react-query";
import { useApiClient, ApiRequestOptions } from "../client";
import { creationEntitiesKeys } from "../creation-entities-keys";
import { formatSearchQuery } from "../../utils/format-search-query";
import {
  InternalUserListPaginatedResponseDtoWithInvitationCount,
  InternalUserListPaginatedResponseDto,
  InternalInvitationListPaginatedResponseDto,
  CreateInternalInvitationRequestDto,
  InternalInvitationResponseDto,
  InternalUserResponseDto,
  UpdateUserRequestDto,
  OrganizationListPaginatedResponseDtoWithCountsAndEntities,
  OrganizationListPaginatedResponseDto,
  OrganizationDetailsResponseDto,
  UpdateOrganizationRequestDto,
  OrganizationResponseDto,
  CustomerUserResponseDto,
  UpdateBanReasonRequestDto,
  UpdateInternalNotesRequestDto,
  DeleteOrganizationRequestDto,
  DeleteOrganizationResponseDto,
  BillingContract,
  UpdateBillingContractRequestDto,
} from "../interfaces/internal.interface";

export interface UseUsersInternalFindInitialParams {
  /**
   * The maximum amount of retrieved items per page
   * @constraints minimum: 1, maximum: 20, default: 20, example: 20
   */
  limit?: number;
  /**
   * The page number to retrieve items from.
   * @constraints minimum: 1, default: 1, example: 1
   */
  page?: number;
  /**
   * The text to search for
   * @constraints minLength: 4, example: Jobdescription
   */
  textSearch?: string;
}

export interface UseUsersInternalFindParams {
  /**
   * The text to search for
   * @constraints minLength: 4, example: Jobdescription
   */
  textSearch?: string;
  /**
   * The maximum amount of retrieved items per page
   * @constraints minimum: 1, maximum: 20, default: 20, example: 20
   */
  limit?: number;
  /**
   * The page number to retrieve items from.
   * @constraints minimum: 1, default: 1, example: 1
   */
  page?: number;
}

export interface UseUsersInternalFindInvitationsParams {
  /**
   * The maximum amount of retrieved items per page
   * @constraints minimum: 1, maximum: 20, default: 20, example: 20
   */
  limit?: number;
  /**
   * The page number to retrieve items from.
   * @constraints minimum: 1, default: 1, example: 1
   */
  page?: number;
}

export interface UseOrganizationsInternalFindInvitationsParams {
  /**
   * The maximum amount of retrieved items per page
   * @constraints minimum: 1, maximum: 20, default: 20, example: 20
   */
  limit?: number;
  /**
   * The page number to retrieve items from.
   * @constraints minimum: 1, default: 1, example: 1
   */
  page?: number;
}

export interface UseOrganizationsInternalFindInitialParams {
  /**
   * The maximum amount of retrieved items per page
   * @constraints minimum: 1, maximum: 20, default: 20, example: 20
   */
  limit?: number;
  /**
   * The page number to retrieve items from.
   * @constraints minimum: 1, default: 1, example: 1
   */
  page?: number;
  /**
   * The text to search for
   * @constraints minLength: 4, example: Jobdescription
   */
  textSearch?: string;
  /** Filter by ban status */
  isBanned?: boolean;
  /** Filter by subscription plan key(s) */
  planKey?: string[];
  /** Filter by subscription status(es) */
  subscriptionStatus?: string[];
  /** Sort field */
  sortBy?: string;
  /** Sort direction */
  sortDirection?: 'asc' | 'desc';
}

export interface UseOrganizationsInternalFindParams {
  /**
   * The maximum amount of retrieved items per page
   * @constraints minimum: 1, maximum: 20, default: 20, example: 20
   */
  limit?: number;
  /**
   * The page number to retrieve items from.
   * @constraints minimum: 1, default: 1, example: 1
   */
  page?: number;
  /**
   * The text to search for
   * @constraints minLength: 4, example: Jobdescription
   */
  textSearch?: string;
  /** Filter by ban status */
  isBanned?: boolean;
  /** Filter by subscription plan key(s) */
  planKey?: string[];
  /** Filter by subscription status(es) */
  subscriptionStatus?: string[];
  /** Sort field */
  sortBy?: string;
  /** Sort direction */
  sortDirection?: 'asc' | 'desc';
}

// Query keys for internal-related queries
export const internalKeys = {
  all: ["internal"] as const,
  users_initial: (params?: any) =>
    [...internalKeys.all, "users_initial", params] as const,
  users: (params?: any) => [...internalKeys.all, "users", params] as const,
  creation_entities: () => [...internalKeys.all, "creation_entities"] as const,
  users_invitations: (params?: any) =>
    [...internalKeys.all, "users_invitations", params] as const,
  users_invitations_mutation: () =>
    [...internalKeys.all, "users_invitations_mutation"] as const,
  users_detail: (params?: any) =>
    [...internalKeys.all, "users_detail", params] as const,
  users_detail_mutation: (params?: any) =>
    [...internalKeys.all, "users_detail_mutation", params] as const,
  users_invitations_detail_mutation: (params?: any) =>
    [...internalKeys.all, "users_invitations_detail_mutation", params] as const,
  organizations_invitations: (params?: any) =>
    [...internalKeys.all, "organizations_invitations", params] as const,
  organizations_invitations_mutation: () =>
    [...internalKeys.all, "organizations_invitations_mutation"] as const,
  organizations_invitations_detail_mutation: (params?: any) =>
    [...internalKeys.all, "organizations_invitations_detail_mutation", params] as const,
  organizations_initial: (params?: any) =>
    [...internalKeys.all, "organizations_initial", params] as const,
  organizations: (params?: any) =>
    [...internalKeys.all, "organizations", params] as const,
  organizations_detail: (params?: any) =>
    [...internalKeys.all, "organizations_detail", params] as const,
  organizations_detail_mutation: (params?: any) =>
    [...internalKeys.all, "organizations_detail_mutation", params] as const,
  organizations_detail_resetAdminPassword_mutation: (params?: any) =>
    [
      ...internalKeys.all,
      "organizations_detail_resetAdminPassword_mutation",
      params,
    ] as const,
  organizations_detail_user_detail_mutation: (params?: any) =>
    [
      ...internalKeys.all,
      "organizations_detail_user_detail_mutation",
      params,
    ] as const,
  organizations_detail_banReason_mutation: (params?: any) =>
    [
      ...internalKeys.all,
      "organizations_detail_banReason_mutation",
      params,
    ] as const,
  organizations_detail_internalNotes_mutation: (params?: any) =>
    [
      ...internalKeys.all,
      "organizations_detail_internalNotes_mutation",
      params,
    ] as const,
  organizations_detail_delete_mutation: (params?: any) =>
    [
      ...internalKeys.all,
      "organizations_detail_delete_mutation",
      params,
    ] as const,
  organizations_billing_contract: (params?: any) =>
    [...internalKeys.all, "organizations_billing_contract", params] as const,
};

/**
 * Find internal staff users with pagination and details for initial request
 */
export function useUsersInternalFindInitial(
  params?: UseUsersInternalFindInitialParams,
  options?: Omit<
    UseSuspenseQueryOptions<InternalUserListPaginatedResponseDtoWithInvitationCount>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useSuspenseQuery({
    queryKey: [
      ...internalKeys.users_initial({ ...params }),
      ...creationEntitiesKeys.list(),
    ],
    queryFn: () => {
      const queryString = formatSearchQuery(params);
      return apiRequest<InternalUserListPaginatedResponseDtoWithInvitationCount>(
        `/internal/users/initial${queryString}`,
      );
    },
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Non-suspense version of useUsersInternalFindInitial
 */
export function useUsersInternalFindInitialQuery(
  params?: UseUsersInternalFindInitialParams,
  options?: Omit<
    UseQueryOptions<InternalUserListPaginatedResponseDtoWithInvitationCount>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useQuery({
    queryKey: [
      ...internalKeys.users_initial({ ...params }),
      ...creationEntitiesKeys.list(),
    ],
    queryFn: () => {
      const queryString = formatSearchQuery(params);
      return apiRequest<InternalUserListPaginatedResponseDtoWithInvitationCount>(
        `/internal/users/initial${queryString}`,
      );
    },
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Find internal staff users with pagination
 */
export function useUsersInternalFind(
  params?: UseUsersInternalFindParams,
  options?: Omit<
    UseSuspenseQueryOptions<InternalUserListPaginatedResponseDto>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useSuspenseQuery({
    queryKey: [
      ...internalKeys.users({ ...params }),
      ...creationEntitiesKeys.list(),
    ],
    queryFn: () => {
      const queryString = formatSearchQuery(params);
      return apiRequest<InternalUserListPaginatedResponseDto>(
        `/internal/users${queryString}`,
      );
    },
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Non-suspense version of useUsersInternalFind
 */
export function useUsersInternalFindQuery(
  params?: UseUsersInternalFindParams,
  options?: Omit<
    UseQueryOptions<InternalUserListPaginatedResponseDto>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useQuery({
    queryKey: [
      ...internalKeys.users({ ...params }),
      ...creationEntitiesKeys.list(),
    ],
    queryFn: () => {
      const queryString = formatSearchQuery(params);
      return apiRequest<InternalUserListPaginatedResponseDto>(
        `/internal/users${queryString}`,
      );
    },
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Get internal staff users invitations creation entities
 */
export function useUsersInternalinvitationsCreationEntities(
  options?: Omit<UseSuspenseQueryOptions<any>, "queryKey" | "queryFn">,
) {
  const { apiRequest } = useApiClient();

  return useSuspenseQuery({
    queryKey: creationEntitiesKeys.list(),
    queryFn: () =>
      apiRequest<any>(`/internal/users/invitations/creation-entities`),
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Non-suspense version of useUsersInternalinvitationsCreationEntities
 */
export function useUsersInternalinvitationsCreationEntitiesQuery(
  options?: Omit<UseQueryOptions<any>, "queryKey" | "queryFn">,
) {
  const { apiRequest } = useApiClient();

  return useQuery({
    queryKey: creationEntitiesKeys.list(),
    queryFn: () =>
      apiRequest<any>(`/internal/users/invitations/creation-entities`),
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Find internal staff users invitations with pagination
 */
export function useUsersInternalFindInvitations(
  params?: UseUsersInternalFindInvitationsParams,
  options?: Omit<
    UseSuspenseQueryOptions<InternalInvitationListPaginatedResponseDto>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useSuspenseQuery({
    queryKey: [
      ...internalKeys.users_invitations({ ...params }),
      ...creationEntitiesKeys.list(),
    ],
    queryFn: () => {
      const queryString = formatSearchQuery(params);
      return apiRequest<InternalInvitationListPaginatedResponseDto>(
        `/internal/users/invitations${queryString}`,
      );
    },
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Non-suspense version of useUsersInternalFindInvitations
 */
export function useUsersInternalFindInvitationsQuery(
  params?: UseUsersInternalFindInvitationsParams,
  options?: Omit<
    UseQueryOptions<InternalInvitationListPaginatedResponseDto>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useQuery({
    queryKey: [
      ...internalKeys.users_invitations({ ...params }),
      ...creationEntitiesKeys.list(),
    ],
    queryFn: () => {
      const queryString = formatSearchQuery(params);
      return apiRequest<InternalInvitationListPaginatedResponseDto>(
        `/internal/users/invitations${queryString}`,
      );
    },
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Invite internal staff user
 */
export function useUsersInternalCreateInvitation(
  options?: Omit<
    UseMutationOptions<
      InternalInvitationResponseDto,
      Error,
      CreateInternalInvitationRequestDto
    >,
    "mutationFn"
  >,
) {
  const { apiRequest } = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: (data: CreateInternalInvitationRequestDto) =>
      apiRequest<InternalInvitationResponseDto>(
        `/internal/users/invitations`,
        "POST",
        data,
      ),
    onSuccess: (data, variables, context) => {
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: internalKeys.all });
      // Invalidate all queries that contain creation entities keys
      queryClient.invalidateQueries({
        predicate: (query) => {
          const queryKey = query.queryKey as string[];
          return queryKey.includes("creation-entities");
        },
      });
      // Call user-provided onSuccess if it exists
      options?.onSuccess?.(data, variables, context);
    },
  });
}

/**
 * Get billing contract for organization
 */
export function useOrganizationsInternalGetBillingContract(
  id: string,
  options?: Omit<
    UseSuspenseQueryOptions<BillingContract | null>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useSuspenseQuery({
    queryKey: internalKeys.organizations_billing_contract({ id }),
    queryFn: () =>
      apiRequest<BillingContract | null>(`/internal/billing/contracts/${id}`),
    // Default cache-disabling options
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Non-suspense version of useOrganizationsInternalGetBillingContract
 */
export function useOrganizationsInternalGetBillingContractQuery(
  id: string,
  options?: Omit<
    UseQueryOptions<BillingContract | null>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useQuery({
    queryKey: internalKeys.organizations_billing_contract({ id }),
    queryFn: () =>
      apiRequest<BillingContract | null>(`/internal/billing/contracts/${id}`),
    // Default cache-disabling options
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Update billing contract
 */
export function useOrganizationsInternalUpdateBillingContract(
  options?: Omit<
    UseMutationOptions<
      BillingContract,
      Error,
      { id: string; data: UpdateBillingContractRequestDto; requestOptions?: ApiRequestOptions }
    >,
    "mutationFn"
  >,
) {
  const { apiRequest } = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: ({
      id,
      data,
      requestOptions
    }: {
      id: string;
      data: UpdateBillingContractRequestDto;
      requestOptions?: ApiRequestOptions;
    }) =>
      apiRequest<BillingContract>(
        `/internal/billing/contracts/${id}`,
        "PATCH",
        data,
        undefined,
        requestOptions
      ),
    onSuccess: (data, variables, context) => {
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: internalKeys.all });
      options?.onSuccess?.(data, variables, context);
    },
  });
}

/**
 * Delete billing contract
 */
export function useOrganizationsInternalDeleteBillingContract(
  options?: Omit<
    UseMutationOptions<
      void,
      Error,
      { id: string; cancelStripeSubscription: boolean }
    >,
    "mutationFn"
  >,
) {
  const { apiRequest } = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: ({ id, cancelStripeSubscription }) =>
      apiRequest<void>(
        `/internal/billing/contracts/${id}?cancelStripeSubscription=${cancelStripeSubscription}`,
        "DELETE",
      ),
    onSuccess: (data, variables, context) => {
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: internalKeys.all });
      options?.onSuccess?.(data, variables, context);
    },
  });
}

/**
 * Get internal staff user
 */
export function useUsersInternalGetUser(
  id: string,
  options?: Omit<
    UseSuspenseQueryOptions<InternalUserResponseDto>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useSuspenseQuery({
    queryKey: [
      ...internalKeys.users_detail({ id }),
      ...creationEntitiesKeys.list(),
    ],
    queryFn: () => apiRequest<InternalUserResponseDto>(`/internal/users/${id}`),
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Non-suspense version of useUsersInternalGetUser
 */
export function useUsersInternalGetUserQuery(
  id: string,
  options?: Omit<
    UseQueryOptions<InternalUserResponseDto>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useQuery({
    queryKey: [
      ...internalKeys.users_detail({ id }),
      ...creationEntitiesKeys.list(),
    ],
    queryFn: () => apiRequest<InternalUserResponseDto>(`/internal/users/${id}`),
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Update internal staff user
 */
export function useUsersInternalUpdateUser(
  options?: Omit<
    UseMutationOptions<
      InternalUserResponseDto,
      Error,
      { id: string; data: UpdateUserRequestDto }
    >,
    "mutationFn"
  >,
) {
  const { apiRequest } = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: ({ id, data }: { id: string; data: UpdateUserRequestDto }) =>
      apiRequest<InternalUserResponseDto>(
        `/internal/users/${id}`,
        "PATCH",
        data,
      ),
    onSuccess: (data, variables, context) => {
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: internalKeys.all });
      // Invalidate all queries that contain creation entities keys
      queryClient.invalidateQueries({
        predicate: (query) => {
          const queryKey = query.queryKey as string[];
          return queryKey.includes("creation-entities");
        },
      });
      // Call user-provided onSuccess if it exists
      options?.onSuccess?.(data, variables, context);
    },
  });
}

/**
 * Abort internal staff user invitation
 */
export function useUsersInternalDeleteInvitation(
  options?: Omit<UseMutationOptions<any, Error, { id: string }>, "mutationFn">,
) {
  const { apiRequest } = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: ({ id }: { id: string }) =>
      apiRequest<any>(`/internal/users/invitations/${id}`, "DELETE"),
    onSuccess: (data, variables, context) => {
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: internalKeys.all });
      // Invalidate all queries that contain creation entities keys
      queryClient.invalidateQueries({
        predicate: (query) => {
          const queryKey = query.queryKey as string[];
          return queryKey.includes("creation-entities");
        },
      });
      // Call user-provided onSuccess if it exists
      options?.onSuccess?.(data, variables, context);
    },
  });
}

/**
 * Resend internal staff user invitation
 */
export function useUsersInternalResendInvitation(
  options?: Omit<UseMutationOptions<any, Error, { id: string }>, "mutationFn">,
) {
  const { apiRequest } = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: ({ id }: { id: string }) =>
      apiRequest<any>(`/internal/users/invitations/${id}/resend`, "POST"),
    onSuccess: (data, variables, context) => {
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: internalKeys.all });
      // Call user-provided onSuccess if it exists
      options?.onSuccess?.(data, variables, context);
    },
  });
}

/**
 * Get organization invitations creation entities
 */
export function useOrganizationsInternalinvitationsCreationEntities(
  options?: Omit<UseSuspenseQueryOptions<any>, "queryKey" | "queryFn">,
) {
  const { apiRequest } = useApiClient();

  return useSuspenseQuery({
    queryKey: creationEntitiesKeys.list(),
    queryFn: () =>
      apiRequest<any>(`/internal/organizations/invitations/creation-entities`),
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Non-suspense version of useOrganizationsInternalinvitationsCreationEntities
 */
export function useOrganizationsInternalinvitationsCreationEntitiesQuery(
  options?: Omit<UseQueryOptions<any>, "queryKey" | "queryFn">,
) {
  const { apiRequest } = useApiClient();

  return useQuery({
    queryKey: creationEntitiesKeys.list(),
    queryFn: () =>
      apiRequest<any>(`/internal/organizations/invitations/creation-entities`),
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}



/**
 * Find organizations with pagination and details for initial request - ALSO USER
 */
export function useOrganizationsInternalFindInitial(
  params?: UseOrganizationsInternalFindInitialParams,
  options?: Omit<
    UseSuspenseQueryOptions<OrganizationListPaginatedResponseDtoWithCountsAndEntities>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useSuspenseQuery({
    queryKey: [
      ...internalKeys.organizations_initial({ ...params }),
      ...creationEntitiesKeys.list(),
    ],
    queryFn: () => {
      const queryString = formatSearchQuery(params);
      return apiRequest<OrganizationListPaginatedResponseDtoWithCountsAndEntities>(
        `/internal/organizations/initial${queryString}`,
      );
    },
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Non-suspense version of useOrganizationsInternalFindInitial
 */
export function useOrganizationsInternalFindInitialQuery(
  params?: UseOrganizationsInternalFindInitialParams,
  options?: Omit<
    UseQueryOptions<OrganizationListPaginatedResponseDtoWithCountsAndEntities>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useQuery({
    queryKey: [
      ...internalKeys.organizations_initial({ ...params }),
      ...creationEntitiesKeys.list(),
    ],
    queryFn: () => {
      const queryString = formatSearchQuery(params);
      return apiRequest<OrganizationListPaginatedResponseDtoWithCountsAndEntities>(
        `/internal/organizations/initial${queryString}`,
      );
    },
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Find organizations with pagination - ALSO USER
 */
export function useOrganizationsInternalFind(
  params?: UseOrganizationsInternalFindParams,
  options?: Omit<
    UseSuspenseQueryOptions<OrganizationListPaginatedResponseDto>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useSuspenseQuery({
    queryKey: [
      ...internalKeys.organizations({ ...params }),
      ...creationEntitiesKeys.list(),
    ],
    queryFn: () => {
      const queryString = formatSearchQuery(params);
      return apiRequest<OrganizationListPaginatedResponseDto>(
        `/internal/organizations${queryString}`,
      );
    },
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Non-suspense version of useOrganizationsInternalFind
 */
export function useOrganizationsInternalFindQuery(
  params?: UseOrganizationsInternalFindParams,
  options?: Omit<
    UseQueryOptions<OrganizationListPaginatedResponseDto>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useQuery({
    queryKey: [
      ...internalKeys.organizations({ ...params }),
      ...creationEntitiesKeys.list(),
    ],
    queryFn: () => {
      const queryString = formatSearchQuery(params);
      return apiRequest<OrganizationListPaginatedResponseDto>(
        `/internal/organizations${queryString}`,
      );
    },
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Find organization details
 */
export function useOrganizationsInternalFindOne(
  id: string,
  options?: Omit<
    UseSuspenseQueryOptions<OrganizationDetailsResponseDto>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useSuspenseQuery({
    queryKey: [
      ...internalKeys.organizations_detail({ id }),
      ...creationEntitiesKeys.list(),
    ],
    queryFn: () =>
      apiRequest<OrganizationDetailsResponseDto>(
        `/internal/organizations/${id}`,
      ),
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Non-suspense version of useOrganizationsInternalFindOne
 */
export function useOrganizationsInternalFindOneQuery(
  id: string,
  options?: Omit<
    UseQueryOptions<OrganizationDetailsResponseDto>,
    "queryKey" | "queryFn"
  >,
) {
  const { apiRequest } = useApiClient();

  return useQuery({
    queryKey: [
      ...internalKeys.organizations_detail({ id }),
      ...creationEntitiesKeys.list(),
    ],
    queryFn: () =>
      apiRequest<OrganizationDetailsResponseDto>(
        `/internal/organizations/${id}`,
      ),
    // Default cache-disabling options (can be overridden via options)
    staleTime: 0,
    gcTime: 0, // replaces cacheTime in v5
    refetchOnMount: "always",
    ...options,
  });
}

/**
 * Update organization data
 */
export function useOrganizationsInternalUpdateOrganizationData(
  options?: Omit<
    UseMutationOptions<
      OrganizationResponseDto,
      Error,
      { id: string; data: UpdateOrganizationRequestDto }
    >,
    "mutationFn"
  >,
) {
  const { apiRequest } = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: UpdateOrganizationRequestDto;
    }) =>
      apiRequest<OrganizationResponseDto>(
        `/internal/organizations/${id}`,
        "PATCH",
        data,
      ),
    onSuccess: (data, variables, context) => {
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: internalKeys.all });
      // Invalidate all queries that contain creation entities keys
      queryClient.invalidateQueries({
        predicate: (query) => {
          const queryKey = query.queryKey as string[];
          return queryKey.includes("creation-entities");
        },
      });
      // Call user-provided onSuccess if it exists
      options?.onSuccess?.(data, variables, context);
    },
  });
}

/**
 * Reset organizations admin password
 */
export function useOrganizationsInternalresetAdminPassword(
  options?: Omit<UseMutationOptions<any, Error, { id: string }>, "mutationFn">,
) {
  const { apiRequest } = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: ({ id }: { id: string }) =>
      apiRequest<any>(
        `/internal/organizations/${id}/resetAdminPassword`,
        "POST",
      ),
    onSuccess: (data, variables, context) => {
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: internalKeys.all });
      // Invalidate all queries that contain creation entities keys
      queryClient.invalidateQueries({
        predicate: (query) => {
          const queryKey = query.queryKey as string[];
          return queryKey.includes("creation-entities");
        },
      });
      // Call user-provided onSuccess if it exists
      options?.onSuccess?.(data, variables, context);
    },
  });
}

/**
 * Update customer user
 */
export function useOrganizationsInternalUpdateCustomerUser(
  options?: Omit<
    UseMutationOptions<
      CustomerUserResponseDto,
      Error,
      { organizationId: string; userId: string; data: UpdateUserRequestDto }
    >,
    "mutationFn"
  >,
) {
  const { apiRequest } = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: ({
      organizationId,
      userId,
      data,
    }: {
      organizationId: string;
      userId: string;
      data: UpdateUserRequestDto;
    }) =>
      apiRequest<CustomerUserResponseDto>(
        `/internal/organizations/${organizationId}/user/${userId}`,
        "PATCH",
        data,
      ),
    onSuccess: (data, variables, context) => {
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: internalKeys.all });
      // Invalidate all queries that contain creation entities keys
      queryClient.invalidateQueries({
        predicate: (query) => {
          const queryKey = query.queryKey as string[];
          return queryKey.includes("creation-entities");
        },
      });
      // Call user-provided onSuccess if it exists
      options?.onSuccess?.(data, variables, context);
    },
  });
}

/**
 * Update organization ban reason
 */
export function useOrganizationsInternalUpdateBanReason(
  options?: Omit<
    UseMutationOptions<
      any,
      Error,
      { id: string; data: UpdateBanReasonRequestDto }
    >,
    "mutationFn"
  >,
) {
  const { apiRequest } = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: UpdateBanReasonRequestDto;
    }) =>
      apiRequest<any>(`/internal/organizations/${id}/banReason`, "PATCH", data),
    onSuccess: (data, variables, context) => {
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: internalKeys.all });
      // Invalidate all queries that contain creation entities keys
      queryClient.invalidateQueries({
        predicate: (query) => {
          const queryKey = query.queryKey as string[];
          return queryKey.includes("creation-entities");
        },
      });
      // Call user-provided onSuccess if it exists
      options?.onSuccess?.(data, variables, context);
    },
  });
}

/**
 * Update organization internal notes
 */
export function useOrganizationsInternalUpdateInternalNotes(
  options?: Omit<
    UseMutationOptions<
      any,
      Error,
      { id: string; data: UpdateInternalNotesRequestDto }
    >,
    "mutationFn"
  >,
) {
  const { apiRequest } = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: UpdateInternalNotesRequestDto;
    }) =>
      apiRequest<any>(
        `/internal/organizations/${id}/internalNotes`,
        "PATCH",
        data,
      ),
    onSuccess: (data, variables, context) => {
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: internalKeys.all });
      // Invalidate all queries that contain creation entities keys
      queryClient.invalidateQueries({
        predicate: (query) => {
          const queryKey = query.queryKey as string[];
          return queryKey.includes("creation-entities");
        },
      });
      // Call user-provided onSuccess if it exists
      options?.onSuccess?.(data, variables, context);
    },
  });
}

/**
 * Permanently delete an organization and optionally clean up related data
 */
export function useOrganizationsInternalDelete(
  options?: Omit<
    UseMutationOptions<
      DeleteOrganizationResponseDto,
      Error,
      { id: string; data: DeleteOrganizationRequestDto }
    >,
    "mutationFn"
  >,
) {
  const { apiRequest } = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationKey: internalKeys.organizations_detail_delete_mutation(),
    mutationFn: async ({ id, data }: { id: string; data: DeleteOrganizationRequestDto }) =>
      await apiRequest<DeleteOrganizationResponseDto>(
        `/internal/organizations/${id}`,
        "DELETE",
        data,
      ),
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);

      // Invalidate everything EXCEPT the detail query of the deleted organization
      // to prevent the active detail page from refetching and throwing a 404 before it unmounts.
      void queryClient.invalidateQueries({
        predicate: (query) => {
          const queryKey = query.queryKey;
          if (
            Array.isArray(queryKey) &&
            queryKey[0] === "internal" &&
            queryKey[1] === "organizations_detail" &&
            typeof queryKey[2] === "object" &&
            queryKey[2] !== null &&
            (queryKey[2] as any).id === variables.id
          ) {
            return false;
          }
          return Array.isArray(queryKey) && queryKey.includes("internal");
        },
      });
    },
    onError: (error, variables, context) => {
      console.error(
        JSON.stringify({
          type: "internal-organization-delete-on-error",
          organizationId: variables.id,
          message: error.message,
          debugContext: (error as any)?.debugContext,
        }),
      );
      options?.onError?.(error, variables, context);
    },
  });
}
